import React, { Component } from 'react';
import * as actions from "../Actions";
import { connect } from "react-redux";
import TransactionList from './TransactionList/TransactionListPage';
import TransactionsMenu from './TransactionsMenu/TransactionMenu';
import { Dialog, MenuItem, Menu, Divider } from '@material-ui/core';
import moment from 'moment';
import Spinner from './UI/Spinner/spinner';
import ManageRulesPage from './Rules/ManageRulesPage';
import TransferTransactions from './Modals/TransferTransactions';
import UploadTransactions from './UploadTransactions/UploadTransactions';
import ExportTransactions from './Transaction/ExportTransactions';
import HideColumns from './Modals/HideColumns'
import DisplayXpaMessage from '../components/Common/DisplayXpaMessage';
import { APS_URL } from "../Actions/types";

const savedHidden = localStorage.getItem("hideColumns") ? JSON.parse(localStorage.getItem("hideColumns")) : undefined;
let count = 0;
class AppContainer extends Component {

    state = {
        transactions: this.props.transactions,
        account: { value: 0 },
        uncodedOnly: (localStorage.getItem("uncodedOnly") === 'true'),
        displayAccount: (localStorage.getItem("displayAccount") === 'true'),
        editableDescription: (localStorage.getItem("editableDescription") === 'true'),
        taxTracking: localStorage.getItem("taxTracking") ? (localStorage.getItem("taxTracking") === 'true') : true,
        showRules: false,
        showToolTip: false,
        showModal: false,
        showRemoveModal: false,
        modalType: '',
        menuOpen: null,
        yValue: 7 - (savedHidden ? Object.keys(savedHidden).filter(key => savedHidden[key]).length : 0),
        hideColumns: savedHidden || { reference: false, type: false, quantity: false },
        dateRange: `?dateFrom=${moment.utc().add(-1, 'month').startOf('month').unix()}&dateTo=${moment.utc().endOf('day').unix()}`,
        totalSyncItems: 0,
        gridVersion: Math.random(),
        sortOrder: false,
        sortColumn: '',
        selectCell: {}
    };

    componentDidMount() {

        // getting hash key and value        
        if (this.props.location.hash.length > 1) {
            const hashValue = this.props.location.hash.substring(1);
            const hashObj = hashValue.split("&")
                            .map(item => item.split("=")) 
                            .reduce((pre, [ key, value ]) => ({...pre, [ key ]: value }), {});

            Object.keys(hashObj).forEach(item => {
                localStorage.removeItem(item.toLowerCase());
                localStorage.setItem(item.toLowerCase(), hashObj[item]);
            });
        }
        if (this.props.location.search.length > 10) {
            const queryData = JSON.parse('{"' + decodeURI(this.props.location.search).replace('?', '').replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
            if (queryData.BookID && queryData.BookID !== localStorage.getItem("bookid")) {
                localStorage.removeItem('cognitotoken');
                localStorage.removeItem('isr1');
                localStorage.removeItem("authtype")
            }
            Object.keys(queryData).forEach(item => localStorage.setItem(item.toLowerCase(), queryData[item]));

            if (queryData.startdate && queryData.enddate) {
                this.setState({ dateRange: `?dateFrom=${moment.utc(queryData.startdate, 'DD-MM-YYYY').startOf('day').unix()}&dateTo=${moment.utc(queryData.enddate, 'DD-MM-YYYY').endOf('day').unix()}` });
            }

            this.props.loadData(localStorage.getItem("bookid"), localStorage.getItem("token"), localStorage.getItem("cognitotoken"));

            // If client is xpa and display by account no has not been set then set to display by account number
            if (queryData.cognitotoken && localStorage.getItem("displayAccount") === null) {
                this.setState({ displayAccount: true });
                localStorage.setItem("displayAccount", true);
            }
        } else {
            this.props.loadData(localStorage.getItem("bookid"));
        }

        if (localStorage.getItem("authtype") === 'RAH') this.rahSync = window.setInterval(() => this.syncRAH(), 5000)

        if (localStorage.getItem('cognitotoken')) {
            this.setState({ showModal: true, modalType: 'XPA' });
        }

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.rah.syncing > this.state.totalSyncItems) this.setState({ totalSyncItems: nextProps.rah.syncing });
        if (this.state.account.value === 0 && (this.props.bankAccount !== nextProps.bankAccount)) {
            const isRah = (localStorage.getItem("authtype") === 'RAH') && !localStorage.getItem("cognitotoken");
            const isR1 = localStorage.getItem("isr1") && !localStorage.getItem("cognitotoken");
            const isAccountLinked = account => {
                let accountLinked = true;
                if (isRah) accountLinked = !!account.RAHBankAccountID;
                else if (isR1) accountLinked = !!account.R1BankAccountID;
                return accountLinked;
            }
            // Retrieve the first account when opening FastCoding.
            const firstBankAccount = nextProps.bankAccount.find(account => account.isBankfeed && isAccountLinked(account));
            if (localStorage.getItem('bankid') && localStorage.getItem('bankid') !== 'null') {
                const bankId = localStorage.getItem('bankid').toUpperCase();
                const bankDetails = nextProps.bankAccount.find(item => item.bankId.toUpperCase() === bankId && (isRah ? item.RAHBankAccountID : true))
                if (bankDetails) {
                    this.setState({ account: { value: bankDetails.value, lockoffDate: bankDetails.lockoffDate, bankId: bankDetails.bankId, isCreditCard: bankDetails.isCreditCard } });
                    // localStorage.removeItem('bankid'); 
                } else {
                    this.setState({ account: firstBankAccount ? { value: firstBankAccount.value, bankId: firstBankAccount.bankId, lockoffDate: firstBankAccount.lockoffDate, isCreditCard: firstBankAccount.isCreditCard } : { value: 0, bankId: 0 } });
                }
            } else {
                this.setState({ account: firstBankAccount ? { value: firstBankAccount.value, bankId: firstBankAccount.bankId, lockoffDate: firstBankAccount.lockoffDate, isCreditCard: firstBankAccount.isCreditCard } : { value: 0, bankId: 0 } });
            }
        }
    }

    componentWillUnmount() {
        if (this.rahSync) window.clearInterval(this.rahSync);
    }

    syncRAH() {
        const { rahQueue, timeStamp, rah: { pollInterval, LastSync } } = this.props;
        count += 1;
        if (count >= pollInterval) {
            count = 0;
            rahQueue(localStorage.getItem("bookid"), this.state.dateRange, this.state.account, LastSync, timeStamp);
        }

        //  if (this.state.rahSync) getTransactions(bookId, account, dateRange);
    }


    updateDateRange = (dateRange) => {
        this.setState({ dateRange });
    }

    selectAccount = (account) => {
        this.setState({ account, sortColumn: '' });
        localStorage.setItem("bankid", account.bankId);
    }

    handleSelectCell = (selectCell) => {
        this.setState({ selectCell });
    }

    handleUncodedChanged = () => {
        localStorage.setItem("uncodedOnly", !this.state.uncodedOnly);
        this.setState({ uncodedOnly: !this.state.uncodedOnly });
    }

    handleDisplayAccountChanged = () => {
        localStorage.setItem("displayAccount", !this.state.displayAccount);
        this.setState({ displayAccount: !this.state.displayAccount });
    }

    handleEditableDescription = () => {
        localStorage.setItem("editableDescription", !this.state.editableDescription);
        this.setState({ editableDescription: !this.state.editableDescription });
    }


    handleRefreshGrid = () => {
        this.setState({ gridVersion: Math.random() });
    }

    handleSorting = (sortValue) => {
        this.setState({ sortColumn: sortValue.sortColumn, sortOrder: sortValue.sortOrder, selectCell: { x: sortValue.x, y: sortValue.y, key: sortValue.key, active: false } });
    }

    handleTaxTracking = () => {
        localStorage.setItem("taxTracking", !this.state.taxTracking);
        this.setState({ taxTracking: !this.state.taxTracking });
        this.handleRefreshGrid();
    }

    handleHideColumnChanged = (column) => {
        let yValue = this.state.yValue;
        if (column === 'reference' || column === 'type') {
            yValue = (this.state.hideColumns[column]) ? yValue + 1 : yValue - 1;
        }

        const hideColumns = { ...this.state.hideColumns, [column]: (this.state.hideColumns[column]) ? false : true };
        localStorage.setItem("hideColumns", JSON.stringify(hideColumns));
        this.setState({ hideColumns, yValue });
        this.handleRefreshGrid();
    }

    handleLinkClicked = () => {
        this.setState({ showSpinner: true });
    }

    handleToggleRules = () => {
        this.setState({ showRules: !this.state.showRules });
    }

    handletooltipToggle = (value) => {
        if (this.state.showToolTip !== value) this.setState({ showToolTip: value });
    }

    showModal = (modalType) => {
        this.setState({ showModal: true, modalType, displayAccount: false });
    }

    toggleRemoveModal = () => {
        this.setState({ showRemoveModal: !this.state.showRemoveModal });
    }

    closeModal = () => {
        this.setState({ showModal: false, menuOpen: null });
    }

    postTransfers = (account) => {
        const dates = this.state.dateRange.replace('?dateFrom=', '').replace('dateTo=', '').split('&');
        const postData = {
            clientAccountId: this.state.account.value,
            dateFrom: dates[0],
            dateTo: dates[1]
        }
        this.props.postTransfers(postData, this.state.modalType, localStorage.getItem("bookid"), this.props.timeStamp, this.state.dateRange);
        this.setState({ showModal: false });
    }

    postToRAH = () => {
        const dates = this.state.dateRange.replace('?dateFrom=', '').replace('dateTo=', '').split('&');
        this.props.postToRAH(localStorage.getItem("bookid"), moment.unix(dates[0]).format('DD-MM-YYYY'), moment.unix(dates[1]).format('DD-MM-YYYY'));
        this.setState({ totalSyncItems: 0 });
        // this.rahSyncCheck = window.setInterval(() => this.props.rahSyncCheck(localStorage.getItem("bookid")), 8000)
    }

    importQIF = (data) => {
        const importDetails = { clientAccountId: this.state.account.value, fileName: data.key, records: data.records };
        return this.props.importQIF(importDetails, this.state.account, this.state.dateRange, () => this.setState({ showModal: false }));
    }

    importCSV = (data) => {
        return this.props.importCSV(data, this.state.account, this.state.dateRange, () => this.setState({ showModal: false }));;
    }

    openReportMenu = (value) => {
        this.setState({ menuOpen: value });
    }

    getReport = (report) => {
        this.setState({ menuOpen: null })
        const fileURL = `${APS_URL}${report}/${(report === 'feedSummary') ? '' : `${localStorage.getItem("bookid")}/`}?dateFrom=${localStorage.getItem("startdate")}&dateTo=${localStorage.getItem("enddate")}&authorizationtoken=${localStorage.getItem("cognitotoken")}`
        window.open(fileURL);
    }

    showError = (error) => {
        this.props.showError(error);
    }

    render() {
        const { dateRange, account, uncodedOnly, displayAccount, editableDescription, gridVersion, showToolTip, toggleTime, showModal, modalType } = this.state;
        const isR1 = localStorage.getItem("isr1") === 'true' && !localStorage.getItem("cognitotoken");
        const isRah = (localStorage.getItem("authtype") === 'RAH') && !localStorage.getItem("cognitotoken");
        const isLinkedBankAccount = this.props.bankAccount.find(account => account.RAHBankAccountID && account.isBankfeed);
        
        // return <div style={{ paddingTop: '135px' }}><Spinner apiError={this.props.apiError} /></div>;
        if (!this.props.loadCompleted) return <div style={{ paddingTop: '135px' }}><Spinner apiError={this.props.apiError} /></div>;
        if (isRah && !isLinkedBankAccount) {
            this.props.history.push(`/bfm?BookID=${localStorage.getItem("bookid")}&authtype=RAH`);
        } else if (!isRah && !this.props.bankAccount.length) {
            return <div style={{ paddingTop: '135px' }}><Spinner noAccounts /></div>;
        }
        if (this.state.showRules) return <ManageRulesPage isRah={isRah} isR1={isR1} showTransactions={this.handleToggleRules} taxTracking={this.state.taxTracking} account={account} />;
        const transactions = Object.entries({ ...this.props.transactionsList });

        return (
            <div id="appContainer" style={{ margin: 4 }}>
                <TransactionsMenu
                    updateRange={this.updateRange}
                    dateRange={dateRange}
                    selectAccount={this.selectAccount}
                    accounts={this.props.bankAccount}
                    account={account}
                    setDateRange={this.updateDateRange}
                    toggleFilter={this.handleUncodedChanged}
                    toggleDisplayAccount={this.handleDisplayAccountChanged}
                    toggleEditableDescription={this.handleEditableDescription}
                    toggleTaxTracking={this.handleTaxTracking}
                    refreshGrid={this.handleRefreshGrid}
                    uncodedOnly={uncodedOnly}
                    displayAccount={displayAccount}
                    editableDescription={editableDescription}
                    taxTracking={this.state.taxTracking}
                    isSaving={this.props.isSaving}
                    linkClicked={this.handleLinkClicked}
                    showRules={this.handleToggleRules}
                    tooltipToggle={this.handletooltipToggle}
                    showToolTip={showToolTip}
                    isR1={isR1}
                    isRah={isRah}
                    reportsMenu={this.openReportMenu}
                    showModal={this.showModal}
                    showRemoveModal={this.toggleRemoveModal}
                    onSearchchanged={search => this.setState({ search })}
                    isTransactionToRemove={transactions && transactions.filter(trans => trans[1].manualUpload).length !== 0}
                    codingErrors={this.props.codingErrors} />
                {(this.state.showSpinner)
                    ? <Spinner />
                    : <TransactionList
                        bookId={localStorage.getItem("bookid")}
                        account={account}
                        dateRange={dateRange}
                        uncodedOnly={uncodedOnly}
                        displayAccount={displayAccount}
                        editableDescription={editableDescription}
                        taxTracking={this.state.taxTracking}
                        version={gridVersion}
                        toggleTime={toggleTime}
                        showRules={this.handleToggleRules}
                        isSaving={this.props.isSaving}
                        postToRAH={this.postToRAH}
                        hasGST={this.props.hasGST}
                        showRemoveModal={this.state.showRemoveModal}
                        closeRemoveModal={this.toggleRemoveModal}
                        searchText={this.state.search}
                        hideColumns={this.state.hideColumns}
                        yValue={this.state.yValue}
                        isR1={isR1}
                        isRah={isRah}
                        rahSyncing={this.props.rah.syncing}
                        rahSyncProgress={(this.state.totalSyncItems) ? Math.round((1 - this.props.rah.syncing / this.state.totalSyncItems) * 100) : undefined}
                        retryQueueRAH={() => this.props.retryQueueRAH(localStorage.getItem("bookid"))}
                        queueState={this.props.rah.queueState}
                        handleSorting={this.handleSorting}
                        sortColumn={this.state.sortColumn}
                        sortOrder={this.state.sortOrder}
                        selectCell={this.state.selectCell}
                        handleSelectCell={this.handleSelectCell}
                        lastSync={this.props.rah ? this.props.rah.LastSync : undefined}
                        hasFeeds={this.props.bankAccount.some(bank => bank.isBankfeed)} />}

                <Dialog open={showModal} onClose={this.closeModal} maxWidth={false} fullWidth={false} >
                    {(this.state.modalType === 'columns') &&
                        <HideColumns
                            onClose={this.closeModal}
                            onhideColumns={this.handleHideColumnChanged}
                            hideColumns={this.state.hideColumns}
                            showClassification={Boolean(this.props.classification.length)}
                            showContact={Boolean(this.props.contacts.length)}
                        />}
                    {(this.state.modalType === 'upload') &&
                        <UploadTransactions
                            onClose={this.closeModal}
                            importQIF={this.importQIF}
                            importCSV={this.importCSV}
                            account={this.props.bankAccount.find(item => item.bankId === account.bankId)}
                            showError={this.showError} />}
                    {(this.state.modalType === 'revert') &&
                        <TransferTransactions
                            account={this.props.bankAccount.find(item => item.bankId === account.bankId)}
                            dateRange={dateRange}
                            modalType={modalType}
                            onClose={this.closeModal}
                            onPost={this.postTransfers} />}
                    {(this.state.modalType === 'XPA') && <div style={{ padding: 15 }}><DisplayXpaMessage closeModal={this.closeModal} /></div>}
                    {(this.state.modalType === 'export') && <ExportTransactions
                        onClose={this.closeModal}
                        transactions={this.props.selectedTransactions}
                        contacts={this.props.contacts}
                        classification={this.props.classification}
                        chart={this.props.transactionCodes && this.props.transactionCodes.chart}
                        />}
                </Dialog>

                <Menu id="reportMenu" anchorEl={this.state.menuOpen} open={Boolean(this.state.menuOpen)} onClose={this.closeModal} >
                    <MenuItem onClick={() => this.getReport('gstauditreport')}>
                        GST Audit Report
                    </MenuItem>
                    <MenuItem onClick={() => this.getReport('gstsummaryreport')}>
                        GST Summary
                    </MenuItem>
                    <MenuItem onClick={() => this.getReport('codeReport')}>
                        Transaction Report
                    </MenuItem>
                    <MenuItem onClick={() => this.getReport('uncodeReport')}>
                        Uncoded Transaction Report
                    </MenuItem>
                    <Divider light />
                    <MenuItem onClick={() => this.getReport('feedSummary')}>
                        Feed Collection Summary
                    </MenuItem>
                </Menu>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { bankAccounts, transactionsList, isSaving, loadCompleted, taxPreference, apiError, timeStamp, classification, contacts, codingErrors, selectedTransactions, transactionCodes } = state.transactions;

    return {
        bankAccount: bankAccounts,
        hasGST: taxPreference,
        transactionsList,
        isSaving,
        loadCompleted,
        apiError,
        timeStamp,
        classification,
        contacts,
        rah: state.rah,
        codingErrors,
        selectedTransactions,
        transactionCodes
    };
}

export default connect(mapStateToProps, actions)(AppContainer);


// WEBPACK FOOTER //
// ./src/components/AppContainer.js